import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import {
  putSocialBio,
  type SetBioRequest,
  type SetBioResult,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SetBioResult) => void;
  onError?: (error: unknown) => void;
};

/** Sets the active persona's profile bio (trimmed server-side; empty clears it). */
export const useSetBioMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((data: SetBioRequest) =>
      putSocialBio(data),
    ),
    onSuccess: (result: SetBioResult) => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      onSuccess?.(result);
    },
    onError: (error: unknown) => {
      onError?.(error);
    },
  });
};
